/**
 * Created by chad on 11/1/16.
 */
import CurrencyCodes from './currencyCodes.js';

class CurrencyCodeToNumber {
    constructor() {

    }

    getNumber(currencyCode) {
        if (Object.hasOwn(CurrencyCodes, currencyCode)) {
            return CurrencyCodes[currencyCode];
        }
        return null;
    }
}

export default new CurrencyCodeToNumber();
